"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import Link from "next/link"
import React from "react"
import { Desktop } from "ui"

// Colors reused from hero
const BLUE = "#1988e2"
const TEXT_DARK = "#1f3365"

const FooterShell = styled.footer`
  width: 100%;
  font-family: inherit;
`

const TopPanel = styled.div`
  background: ${BLUE};
  color: #fff;
  position: relative;
  padding: clamp(24px, 3vw, 20px) clamp(24px, 3.5vw, 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: clamp(180px, 18vw, 370px);
  margin-top: clamp(0px, 16vw, 220px);
`

const LogoWrapper = styled.div`
  width: clamp(120px, 30vw, 370px);
  img {
    width: 100%;
    height: auto;
  }
  ${(p) => p.theme.breakpoints.down("md")} {
    width: clamp(140px, 55vw, 240px);
    margin-top: clamp(24px, 6vw, 48px);
  }
`
const DogWrapper = styled.div`
  width: clamp(120px, 40vw, 537px);
  margin-top: clamp(-400px, -30vw, -30px);
  margin-bottom: clamp(-80px, -10vw, -10px);
  margin-inline-end: clamp(-100px, -5vw, -50px);
  img {
    width: 100%;
    height: auto;
  }
`

const BottomPanel = styled.div`
  background: white;
  padding: clamp(28px, 3vw, 60px) clamp(24px, 3.5vw, 56px) clamp(40px, 4vw, 64px);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(18px, 4vw, 60px);
  ${(p) => p.theme.breakpoints.down("md")} {
    flex-direction: column;
  }
`

const LinksRow = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: clamp(14px, 2vw, 36px);
  font-size: clamp(14px, 1vw, 18px);
  font-weight: 500;
  color: ${TEXT_DARK};
  a {
    color: inherit;
    text-decoration: none;
    position: relative;
  }
  a:hover {
    text-decoration: underline;
  }
  flex-shrink: 0;
`

const Divider = styled.span`
  color: ${TEXT_DARK};
  opacity: 0.6;
`

const Disclaimer = styled.p`
  margin: 0;
  max-width: 1200px;
  font-size: clamp(14px, 1vw, 18px);
  line-height: 1.35;
  font-weight: 400;
  color: ${TEXT_DARK};
`

// const Credit = styled.small`
//   font-size: clamp(10px, 0.7vw, 13px);
//   letter-spacing: 0.08em;
//   font-weight: 500;
//   color: ${TEXT_DARK};
//   opacity: 0.8;
//   text-transform: uppercase;
//   margin-top: clamp(24px, 3vw, 48px);
//   a {
//     color: inherit;
//     text-decoration: none;
//   }
//   a:hover {
//     text-decoration: underline;
//   }
// `

const Footer: React.FC = () => {
  return (
    <FooterShell>
      <TopPanel>
        <Desktop>
          <DogWrapper>
            <Image
              src="/landingpages/homeupgrades/footer-dog.png"
              alt="אשטרום מגורים"
              width={537}
              height={710}
              priority
            />
          </DogWrapper>
        </Desktop>
        <LogoWrapper>
          <Image
            src="/landingpages/homeupgrades/footer-logo.svg"
            alt="אשטרום מגורים"
            width={240}
            height={138}
            priority
          />
        </LogoWrapper>
      </TopPanel>
      <BottomPanel>
        <LinksRow aria-label="קישורי מדיניות">
          <Link
            href="https://www.ashtrom.co.il/content/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            מדיניות הפרטיות
          </Link>
          <Divider>|</Divider>
          <Link
            href="https://www.ashtrom.co.il/content/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            תנאי שימוש
          </Link>
          <Divider>|</Divider>
          <Link
            href="https://www.ashtrom-givatshmuel.co.il/הצהרת-נגישות"
            target="_blank"
            rel="noopener noreferrer"
          >
            הצהרת נגישות
          </Link>
        </LinksRow>
        <Disclaimer>
          בפרוייקטים נבחרים בלבד. בכפוף לתקנון המבצע.
          <br />
          ההדמיות נועדו להמחשה כללית בלבד ולמסירת מידע בלבד ואינם מהווים כל התחייבות של החברה.
          הדמיות של אלמנטים מחוץ למגרשים בהם בונה החברה היזמית נכון לתאריך הפקת ההדמיה, הן במגרשים
          שבבעלות אחרים והן במגרשים המיועדים לצרכי ציבור, מהווה אילוסטרציה בלבד ואין בה כדי לחייב את
          החברה היזמית.את החברה מחייב ההסכם והמפרט הטכני, לפי חוק המכר שעליו יחתמו החברה והרוכשים.
        </Disclaimer>
        {/* <Credit>
          DEVELOPED BY{" "}
          <a
            href="https://www.mdesign.co.il"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="MDESIGN אתר"
          >
            MDESIGN
          </a>
        </Credit> */}
      </BottomPanel>
    </FooterShell>
  )
}

export default Footer
